import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import type { RootDispatch, RootState } from '../../../../configuration/setup/store';
import { getIsLoading } from '../../api/redux/api.redux';
import { ApiCalls } from '../../api/redux/types';
import { fetchUsageDownloadThunk } from './usage.thunk';

const UsageDownloadButton = (props: { downloadUsage: () => void; isLoading: boolean }) => {
    const { downloadUsage, isLoading } = props;

    if (isLoading) {
        return (
            <Button
                key='loading'
                className={'btn btn-default btn-loading'}
                type={'button'}
                disabled={true}
                autoTrackingKey={'marketplace.usage.download.button'}
            >
                <FormattedMessage id={'intl-msg:marketplace.usage.download.button'} />
            </Button>
        );
    }

    return (
        <Button
            key='ready'
            className={'btn btn-default'}
            type={'button'}
            onClick={downloadUsage}
            autoTrackingKey={'marketplace.usage.download.button'}
        >
            <span className={'uikit-icon icon-download'} aria-hidden={true} />
            <FormattedMessage id={'intl-msg:marketplace.usage.download.button'} />
        </Button>
    );
};

const mapStateToProps = (state: RootState) => ({
    isLoading: getIsLoading(state, ApiCalls.USAGE_EXPORT),
});

const mapDispatchToProps = (dispatch: RootDispatch) => ({
    downloadUsage: () => dispatch(fetchUsageDownloadThunk),
});

export const UsageDownloadButtonContainer = connect(mapStateToProps, mapDispatchToProps)(UsageDownloadButton);
